import React from 'react';
import {Container, Button, } from 'react-bootstrap';
import img1 from '../images/8401.jpg';
export default function Section3() {
  return ( 
      <section className="section2">
        <div className=" row container-fluid col-12 d-flex "> 
            <div className="intro col-sm-12 col-md-5 col-lg-5 mx-auto">
                <Container> 
                    <div className='text text-right'>
                        <h1>Aptitude</h1> <br />
                        <h6>
                            I'm proficient in Adobe Illustrator and Photoshop, <br />
                            Skilled with pencil, link, Digital tools. I've more than <br />
                            3+ years of Solid Experience on <br/>
                            <ul>
                                <li>
                                    Responsive Web Design 
                                </li>
                                <li>
                                    Landing Page Design 
                                </li>
                                <li>
                                    User Interface Design 
                                </li>
                                <li>
                                    User Experience Design 
                                </li>
                                <li>
                                    Adobe Photoshop 
                                </li>
                                <li>
                                    Adobe Illustrator 
                                </li>
                                <li>
                                    PSD File 
                                </li>
                                <li>
                                    Web & Mobile PSD Layout. 
                                </li>
                            </ul>
                        </h6>
                    </div> 
                    <div>
                        <Button variant='outline-dark'>
                            Know More
                        </Button> 
                    </div>
                    
                </Container>
            </div>
            <div className="into col-6 col-sm-12 col-md-6 col-lg-6 mx-auto">
                <img src= {img1} alt="illustration" />
            </div>
        </div> 
     </section> 
  )
}
